import { render, staticRenderFns } from "./MessagesNew.vue?vue&type=template&id=9cb454dc&"
import script from "./MessagesNew.vue?vue&type=script&lang=js&"
export * from "./MessagesNew.vue?vue&type=script&lang=js&"
import style0 from "./MessagesNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports